import React from 'react';
import SessionManagementPage from './SessionManagementComponents/SessionManagementPage';

const SessionManagementView = (props) => {
  return <SessionManagementPage {...props} />;
};

export default SessionManagementView;
